module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"th":{"empty.default":"พิมพ์เพื่อหาข้อมูล"}}')
  delete Component.options._Ctor
}
